import React from "react"
import Container from "react-bootstrap/Container";

export default function Contact() {
    return (
        <Container as="section" id="contact" style={{marginBottom: "25vh"}}>
            <h3 className={"section-title"} style={{textAlign: `center`}}>Contact</h3>
            <div className="separator pt-3">

                <h1 className={"display-3 my-5 section-subtitle"} style={{textAlign: 'center'}}>I am available for
                    hiring</h1>
                {/*<p style={{textAlign: 'center', marginBottom:0}}>I have just finished my last article and I am open for new projects.</p>*/}
                <p style={{textAlign: 'center', marginTop: 0}}>Send me an email if you are interested in working with
                    me.</p>
                <div style={{textAlign: 'center'}}>
                    <a href="mailto:blauigris@email.com" target="_blank" rel="noopener noreferrer"
                       className="btn btn-primary mt-3">Email me</a>
                </div>

            </div>
        </Container>
    )
}